module.exports = {
	"articleTitle1": "Best Sweet Treat: Washtenaw Dairy ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Washtenaw Dairy",
	"articleLink1": "https://www.michigandaily.com/section/arts/boaa-washtenaw-dairy",
	"articleLink2": "https://www.michigandaily.com/section/arts/boaa-washtenaw-dariy",
	"articleSnippet1": "Apr 2, 2017 ... When people outside of the Midwest imagine local Midwestern dairies, \nWashtenaw Dairy is what they picture.",
	"articleSnippet2": "Apr 3, 2016 ... To find the most scrumptious sweet treat in Ann Arbor, one has to travel a little off \nthe beaten path. You won't stumble upon Washtenaw Dairy ...",
	"foodRecommendations": [],
	"articleTitle2": "Best Sweet Treat: Washtenaw Dairy ",
	"address": "602 S Ashley St, Ann Arbor, MI 48103",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170412/msh.NEW_.WashtenawDairyBAA.4.1.16.166.jpg?itok=Mc2uiGBm",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.27388,
		"lng": -83.750393
	},
	"totalMisc": 1,
	"categories": {
		"dessert": 1,
		"fooddrink": 1,
		"location": 1,
		"bestofaa": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/washtenawdairy.json
// module id = 1000
// module chunks = 0